import React, {Component} from 'react';
import autobind from 'autobind-decorator';
import {Col, Row, Table} from 'react-bootstrap';
import {Glyphicon} from "../GlyphIcon";
import {service as SurveyQuestionDataTypeService} from "../../../Services/SurveyQuestionDataTypeService";


import {SurveyNavigation} from './SurveyNavigation';
import {SurveyFormInput} from './SurveyFormInput';

import {SurveySectionHeader} from "./SurveySectionHeader";
import {SurveySectionFooter} from "./SurveySectionFooter";

import {HelpIcon} from "../HelpIcon";
import {InfoIcon} from "../InfoIcon";

export class SurveyForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            surveyQuestionDataTypes: []
        };
    }

    componentDidMount() {
        //This is a cached Service, so we won't be doing an ajax call per Input. We'll do that call once for the life of the js app.
        SurveyQuestionDataTypeService.Get()
            .then((x) => {
                this.setState({
                    surveyQuestionDataTypes: x.result
                });
            });
    }

    @autobind
    getConservationAction() {
        return this.props.ConservationAction;
    }

    @autobind
    getSections() {
        if(this.props.Survey) {
            let sections = this.props.Survey.SurveySections;

            if(sections) {
                return sections.sort((a, b) => Number(a.order) - Number(b.order));
            }
        }

        return [];
    }

    @autobind
    getQuestionsForSection(section) {
        if(section && section.SurveyQuestions) {
            let questions = section.SurveyQuestions;

            if(questions) {
                return questions.sort((a, b) => Number(a.order) - Number(b.order));
            }
        }

        return [];
    }

    @autobind
    getAnswerQuestion(answer) {
        let sections = this.getSections();

        for(let i = 0; i < sections.length; i++) {
            let section = sections[i];
            let questions = section.SurveyQuestions;
            for(let h = 0; h < questions.length; h++) {
                let question = questions[h];

                if(question.surveyQuestionId == answer.surveyQuestionId) {
                    return question;
                }
            }
        }

        return null;
    }

    @autobind
    getQuestionAnswer(question) {
        let answers = this.props.Answers;
        if(answers) {
            let answer = answers.find((x) => x.surveyQuestionId == question.surveyQuestionId);

            if(answer) {
                return answer;
            }
        }

        return null;
    }

    @autobind
    getQuestionValidation(question) {
        if (question.surveyQuestionId in this.props.Validation) {
            return this.props.Validation[question.surveyQuestionId];
        }

        return null;
    }

    @autobind
    isLabel(id) {
        const label = this.state.surveyQuestionDataTypes.find(x => x.code === 'label');

        if (!label) {
            return false;
        }

        return id === label.surveyQuestionDataTypeId;
    }

    render() {
        const { surveyQuestionDataTypes } = this.state;
        const { Survey, CustomSections, EditMode, CustomData } = this.props;
        const conservationAction = this.getConservationAction();
        const sections = this.getSections();

        // pass-through event handlers
        const {
            DeleteAnswer, OnAnswerChange,
            OnConservationActionChange, OnCustomDataChange,
            OnFinish, OnSave, OnValidation
        } = this.props;

        if(conservationAction) {
            return <Row className={"sb-survey-form " + (EditMode ? "editing " : "")} >
                <Col xs={9}>
                    {
                        sections.map((section, sectionIndex) => {
                            let lastIndex = (sections.length === (sectionIndex + 1));

                            let surveySectionFooter = <SurveySectionFooter editMode={this.props.EditMode} lastIndex={lastIndex}
                                                                           onSaveAndFinish={OnFinish} isValid={this.props.IsValid}
                                                                           onSaveAndContinue={OnSave}/>;

                            if(CustomSections) {
                                if(CustomSections[section.code]) {
                                    let overrides = {
                                        component: CustomSections[section.code]
                                    };

                                    return <overrides.component
                                        key={section.surveySectionId}
                                        id={"sb-survey-section-" + section.surveySectionId}
                                        className="sb-survey-section"
                                        Survey={Survey}
                                        Section={section}
                                        EditMode={EditMode}
                                        ConservationAction={conservationAction}
                                        GetQuestionsForSection={() => this.getQuestionsForSection(section)}
                                        GetQuestionAnswer={this.getQuestionAnswer}
                                        GetAnswerQuestion={this.getAnswerQuestion}
                                        GetQuestionValidation={this.getQuestionValidation}
                                        CustomData={CustomData}
                                        OnAnswerChange={OnAnswerChange}
                                        OnValidation={OnValidation}
                                        DeleteAnswer={DeleteAnswer}
                                        OnConservationActionChange={OnConservationActionChange}
                                        OnCustomDataChange={OnCustomDataChange}
                                        OnSave={OnSave}
                                        Footer={surveySectionFooter}
                                    />;
                                }
                            }

                            return <Col key={section.surveySectionId}
                                        id={"sb-survey-section-" + section.surveySectionId}
                                        className="sb-survey-section">
                                <SurveySectionHeader section={section}/>
                                <Row>
                                    <Col xs={12}>
                                        <Table className="sb-survey-form-table" striped bordered>
                                            <tbody>
                                            {
                                                this.getQuestionsForSection(section).map((y) => {
                                                    const labelClass = this.isLabel(y.surveyQuestionDataTypeId) ? 'sb-survey-label' : '';

                                                    let label = <span className={labelClass}>{y.name}<InfoIcon
                                                        link={y.infoLink}>{y.infoTitle}</InfoIcon></span>;
                                                    if (y.helpText) {
                                                        label = <span className={labelClass}>{y.name}
                                                            <HelpIcon placement="right" id={"survey-question-tooltip-" + y.surveyQuestionId}>
                                                                {y.helpText}
                                                            </HelpIcon>
                                                            <InfoIcon link={y.infoLink}>
                                                                {y.infoTitle}
                                                            </InfoIcon>
                                                        </span>
                                                    }

                                                    const description = y?.PermitType?.description || y.description || null;

                                                    return <tr key={y.surveyQuestionId}>
                                                        <td>
                                                            {label}
                                                            {description &&
                                                            <p className="description">{description}</p>}
                                                        </td>
                                                        <td>
                                                            <SurveyFormInput
                                                                SurveyTypeId={Survey.surveyTypeId}
                                                                SurveyQuestionDataTypes={surveyQuestionDataTypes}
                                                                ConservationAction={conservationAction}
                                                                Question={y}
                                                                Validation={this.getQuestionValidation(y)}
                                                                Answer={this.getQuestionAnswer(y)}
                                                                OnChange={OnAnswerChange}
                                                                OnConservationActionChange={OnConservationActionChange}
                                                                OnValidation={OnValidation}
                                                                EditMode={this.props.EditMode}
                                                            />
                                                        </td>
                                                    </tr>;
                                                })
                                            }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                {surveySectionFooter}
                            </Col>;
                        })
                    }
                </Col>
                <Col xs={3} className="sb-section-navigator">
                    <SurveyNavigation
                        Sections={this.getSections()}
                        GetQuestionAnswer={this.getQuestionAnswer}
                        Survey={Survey}
                        ConservationAction={this.getConservationAction()}
                        CustomSections={CustomSections}
                        CustomData={CustomData}
                    />
                </Col>
            </Row>;
        }

        return null;
    }
}


